import React, {VoidFunctionComponent} from 'react';

import SVGIcon, {SVGIconProps} from '../svg-icon/svg-icon';

const FilterIcon: VoidFunctionComponent<SVGIconProps> = props => (
  <SVGIcon {...props} viewBox={'0 0 20 13'}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0v2.167h19.5V0H0zm0 12.167h6.5V10H0v2.167zm13-5H0V5h13v2.167z"
      fill="currentColor"
    />
  </SVGIcon>
);

export default FilterIcon;
